<template>
  <CategoryForm :element="category" :onSubmit="submit"></CategoryForm>
</template>

<script>
import CategoryForm from './category-form.vue';
import { busEvent } from '../events/bus';

export default {
  name: 'EditCategory',
  components: {
    CategoryForm,
  },
  created() {
    this.$store.dispatch('category/getCategory', {
      appId: this.$route.params.appId,
      categoryId: this.$route.params.categoryId,
    });
  },
  computed: {
    category() {
      return this.$store.state.category.category;
    },
  },
  methods: {
    submit() {
      this.$store.dispatch('category/update', {
        appId: this.$route.params.appId,
        categoryId: this.$route.params.categoryId,
        body: this.category,
      })
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Informatie actualizata');
        });
    },
  },
};
</script>
